import { useRef, useState } from 'react';
import debounce from 'lodash.debounce';
import { apiClient } from '../../../../api/httpClient';
import { EMAIL_DEBOUNCE_TIMEOUT } from '../../../../globals/utils/constants';
import { INTERNAL_USER_ENDPOINTS } from './internalUserFormConfig';

export const useInternalUserEmailCheck = ({ onEmailClear } = {}) => {
  const [emailExists, setEmailExists] = useState(false);
  const [emailChecking, setEmailChecking] = useState(false);
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);

  const debouncedCheckEmail = useRef(
    debounce(async (email) => {
      if (!email) {
        setEmailExists(false);
        setEmailChecking(false);
        setEmailDialogOpen(false);
        return;
      }
      setEmailChecking(true);
      try {
        await apiClient(INTERNAL_USER_ENDPOINTS.emailExists, 'POST', { email });
        setEmailExists(false);
      } catch (error) {
        if (error?.detail === 'Email already exists') {
          setEmailDialogOpen(true);
          setEmailExists(true);
        } else {
          setEmailExists(false);
        }
      } finally {
        setEmailChecking(false);
      }
    }, EMAIL_DEBOUNCE_TIMEOUT)
  ).current;

  const handleEmailChange = (email) => {
    debouncedCheckEmail(email);
  };

  const handleDialogClose = () => {
    setEmailDialogOpen(false);
  };

  const handleDialogContinue = () => {
    setEmailDialogOpen(false);
    setEmailExists(false);
  };

  const handleDialogCancel = () => {
    setEmailDialogOpen(false);
    onEmailClear?.();
    setEmailExists(false);
  };

  return {
    emailExists,
    emailChecking,
    emailDialogOpen,
    handleEmailChange,
    handleDialogClose,
    handleDialogContinue,
    handleDialogCancel,
  };
};
